
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

const url = process.env.REACT_APP_SERVER_URL
const proxyUrl = process.env.REACT_APP_IMG_PROXY_URL
const api = new ExhibitionClient({url, proxyUrl})

export default api
